import type { BrowserInfo } from '@snapchat/client-hints';

/**
 * @deprecated Use {@link BrowserInfo} directly.
 *
 *   TODO: Delete this.
 */
export type BrowserFeatures = BrowserInfo;
